import BaseStore from '@/store/base-store'
import http from '@/services/http.service'

const options = {
  state: {
    metGoals: {},
    globalMetGoals: {},
    globalGoals: []
  },
  getters: {
    metGoals (state) {
      return state.metGoals
    },
    globalMetGoals (state) {
      return state.globalMetGoals
    },
    globalGoals (state) {
      return state.metGoals
    }
  },
  mutations: {
    metGoals (state, payload) {
      state.metGoals = payload
    },
    globalMetGoals (state, payload) {
      state.globalMetGoals = payload
    },
    globalGoals (state, payload) {
      state.globalGoals = payload
    }
  },
  actions: {
    metGoals ({commit}, payload) {
      return http.get('met-goals/branch', {params: payload}).then(response => {
        commit('metGoals', response.data)
        return response
      })
    },
    globalGoals ({commit}, payload) {
      return http.get('global-goals', {params: payload}).then(response => {
        commit('globalGoals', response.data)
        return response
      })
    },
    globalMetGoals ({commit}, payload) {
      return http.get('met-goals/branch', {params: payload}).then(response => {
        commit('globalMetGoals', response.data)
        return response
      })
    }
  }
}
let myGoals = new BaseStore('branch-goals', options)
export default myGoals



// WEBPACK FOOTER //
// ./src/store/modules/branch-goals.store.js